/* ============================================================================
   announcement-delivery-co.js — iShop Colombia (v2, arquitectura PE)
   Construye el copy de la barra a partir de la zona resuelta.
   Depende de: coverage-co-data.js, coverage-co.js, ANNOUNCEMENT_CONFIG_CO.
   ----------------------------------------------------------------------------
   ARQUITECTURA (igual al patrón probado de Perú):
   - UN SOLO heartbeat de 1 s que RECALCULA el mensaje completo desde el
     estado ACTUAL en cada tick (zona fresca vía COCoverage.current() + hora
     fresca vía nowCO()). No hay closures que congelen zona ni deadline:
     es imposible que un tick viejo pinte una zona anterior.
   - El handle del heartbeat vive en window.__CO_ANN_TIMER: si el script se
     carga dos veces (doble script tag, harness + theme), la carga nueva
     MATA el heartbeat de la anterior. Una sola fuente de pintado, siempre.
   - El DOM solo se escribe cuando el HTML cambia (dedupe), así el heartbeat
     de 1 s no genera churn: los mensajes estáticos se escriben una vez y
     el countdown cambia una vez por segundo, como debe.
   REGLAS DE COPY: ver reglas_negocio_announcement_co.docx.
   Hora Colombia con offset fijo UTC-5 (sin DST).
   ============================================================================ */
(function (w) {
  'use strict';

  var TZ_OFFSET_MIN = -5 * 60; /* America/Bogota, fijo */
  var DIAS  = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio',
               'agosto','septiembre','octubre','noviembre','diciembre'];

  function cfg() { return w.ANNOUNCEMENT_CONFIG_CO || {}; }

  /* ---------- tiempo Colombia ---------- */
  /* Hook de QA: si window.__CO_TEST_NOW = {baseMs, setAtMs} está definido,
     el "ahora" simulado corre desde baseMs (avanza en tiempo real para que
     el countdown funcione). Inofensivo en producción. */
  function nowCO() {
    if (w.__CO_TEST_NOW && w.__CO_TEST_NOW.baseMs) {
      return new Date(w.__CO_TEST_NOW.baseMs + (Date.now() - w.__CO_TEST_NOW.setAtMs));
    }
    var d = new Date();
    return new Date(d.getTime() + (d.getTimezoneOffset() + TZ_OFFSET_MIN) * 60000);
  }
  function ymd(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }
  function holidaySet() {
    var list = cfg().feriados || [], s = {}, i, v;
    for (i = 0; i < list.length; i++) {
      v = String(list[i]).trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) s[v] = true;
    }
    return s;
  }
  function isBusinessDay(d, hs) {
    var dow = d.getDay();
    if (dow === 0 || dow === 6) return false;
    return !hs[ymd(d)];
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }

  /* Regla nacional (fuera de Bogotá): HOY NUNCA cuenta como día hábil.
     El conteo de los n días hábiles arranca en el siguiente día hábil
     (ese siguiente hábil = día 1). Entrega = n-ésimo día hábil
     estrictamente posterior a hoy. */
  function addBusinessDays(from, n, hs) {
    var d = new Date(from.getTime()), added = 0;
    while (added < n) {
      d = addDays(d, 1);
      if (isBusinessDay(d, hs)) added++;
    }
    return d;
  }

  /* ---------- render de nombre del día ---------- */
  function calendarDaysBetween(a, b) {
    var A = new Date(a.getFullYear(), a.getMonth(), a.getDate());
    var B = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.round((B - A) / 86400000);
  }
  /* Devuelve el fragmento de envío ya formateado (sin prefijo de zona). */
  function shippingCopy(target, isRange, today) {
    var c = cfg();
    var diff = calendarDaysBetween(today, target);
    var diaNombre = DIAS[target.getDay()];
    if (diff <= 0) return null; /* "hoy" lo maneja el flujo Bogotá */
    if (diff === 1) {
      return (c.txtEnvioManana || 'recibe tu pedido <strong>mañana</strong>');
    }
    if (diff <= 7) {
      var t = isRange ? (c.txtEnvioDiaOAntes || 'recibe tu pedido <strong>el {dia} o antes</strong>')
                      : (c.txtEnvioDia || 'recibe tu pedido <strong>el {dia}</strong>');
      return t.replace('{dia}', diaNombre);
    }
    /* más allá de una semana: día + fecha ("el lunes 16 de noviembre") */
    var fecha = target.getDate() + ' de ' + MESES[target.getMonth()];
    var tf = isRange ? (c.txtEnvioFechaOAntes || 'recibe tu pedido <strong>el {dia} {fecha} o antes</strong>')
                     : (c.txtEnvioFecha || 'recibe tu pedido <strong>el {dia} {fecha}</strong>');
    return tf.replace('{dia}', diaNombre).replace('{fecha}', fecha);
  }

  function fmtHora12(h) {
    if (h === 12) return '12:00 m';
    if (h > 12) return (h - 12) + ':00 p.m.';
    return h + ':00 a.m.';
  }
  function fmtCountdown(msLeft) {
    var s = Math.max(0, Math.floor(msLeft / 1000));
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    function pad(x) { return x < 10 ? '0' + x : '' + x; }
    return (h > 0 ? h + ':' : '') + pad(m) + ':' + pad(sec);
  }

  /* ---------- retiro en tienda ----------
     Texto ESTÁTICO: todos los días, incluidos festivos. Sin horarios,
     sin "hoy" ni "mañana". Solo en ubicaciones donde aplica. */
  function pickupCopy() {
    return cfg().txtRecojo || 'Retiro en tienda en <strong>1h</strong>';
  }

  /* ---------- envío Bogotá (función PURA: calcula, no agenda timers) ---------- */
  function bogotaShippingCopy(now, hs) {
    var c = cfg();
    var corte = c.corteMismoDiaBogota != null ? c.corteMismoDiaBogota : 11;
    var cdStart = c.countdownInicio != null ? c.countdownInicio : 9;
    var urgente = c.countdownUrgente != null ? c.countdownUrgente : 10;
    var h = now.getHours() + now.getMinutes() / 60;

    if (isBusinessDay(now, hs) && h < corte) {
      if (h < cdStart) {
        return (c.txtEnvioHoy || 'recibe tu pedido <strong>HOY</strong> si compras antes de las <strong>{hora}</strong>')
          .replace('{hora}', fmtHora12(corte));
      }
      var deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), corte, 0, 0);
      var left = deadline - now;
      var tpl = (h >= urgente)
        ? (c.txtEnvioHoyUrgente || 'últimos {cd} para recibir tu pedido <strong>HOY</strong>')
        : (c.txtEnvioHoyCountdown || 'quedan {cd} para recibir tu pedido <strong>HOY</strong>');
      return tpl.replace('{cd}', '<span class="js-cd">' + fmtCountdown(left) + '</span>');
    }

    /* después del corte, o sáb/dom/feriado:
       entrega = siguiente día hábil estrictamente posterior a hoy */
    var target = addBusinessDays(new Date(now.getFullYear(), now.getMonth(), now.getDate()), 1, hs);
    return shippingCopy(target, false, now);
  }

  /* ---------- render ---------- */
  /* Dedupe consciente del DOM: guardamos la intención (html pedido) y lo
     APLICADO (innerHTML normalizado por el navegador tras escribir). Solo
     saltamos la escritura si ambos coinciden. Si algo externo reemplazó el
     nodo o su contenido (p. ej. el THEME EDITOR de Shopify re-renderiza la
     sección al tocar un setting, o el resetBar del harness), lastApplied ya
     no coincide y el heartbeat re-pinta en el siguiente tick. */
  var lastIntent = null, lastApplied = null;
  function setMessage(html) {
    var el = document.querySelector('#announcement-bar-section .ann-slide[data-index="0"] .message-part');
    if (!el) return;
    if (html === lastIntent && el.innerHTML === lastApplied) return;
    el.innerHTML = html;
    lastIntent = html;
    lastApplied = el.innerHTML; /* forma normalizada del navegador */
  }

  /* Calcula el HTML completo del mensaje para el estado actual, o null si
     no hay ubicación (se conserva el mensaje por defecto). */
  function composeMessage(res) {
    if (!res || !res.sla) return null;
    var c = cfg();

    if (res.sla.noDelivery) {
      return c.txtSinCobertura ||
        'Entrega en todo el país (excepto Archipiélago de San Andrés, Providencia y Santa Catalina)';
    }

    var now = nowCO();
    var hs = holidaySet();
    var sep = c.txtSeparador || '  ·  ';
    var zona = (c.txtEnZona || 'En {zona}').replace('{zona}', res.sla.label || 'tu municipio');
    if (zona && !/\s$/.test(zona)) zona += ' '; /* el theme editor recorta espacios finales */

    var shipPart;
    if (res.sla.sameDay) {
      shipPart = bogotaShippingCopy(now, hs);
    } else {
      /* fuera de Bogotá: sin tope de hora; hoy nunca cuenta.
         Ej.: pedido martes n=2 -> mié(1), jue(2) -> jueves.
              pedido sábado n=2 -> lun(1), mar(2) -> martes. */
      var hoy0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var target = addBusinessDays(hoy0, res.sla.n, hs);
      shipPart = shippingCopy(target, !!res.sla.range, now);
    }

    var showPickup = !!res.pickup && (res.zoneKey !== 'bogota' || res.bogotaNorte === true);
    var parts = [];
    if (shipPart) parts.push(shipPart);              /* ENVÍO primero */
    if (showPickup) parts.push(pickupCopy());        /* retiro después */
    if (!parts.length) return null;
    return zona + parts.join(sep);
  }

  /* Zona SIEMPRE fresca: se pide a COCoverage en cada tick. Nada de
     lastRes cacheados por instancia. */
  function currentRes() {
    return (w.COCoverage && w.COCoverage.current) ? w.COCoverage.current() : null;
  }

  function repaint() {
    var html = composeMessage(currentRes());
    if (html != null) setMessage(html);
  }

  /* ---------- init: heartbeat único con takeover ---------- */
  var hbTicks = 0;
  function heartbeat() {
    repaint();
    /* Cada ~15 s re-chequea el permiso de geolocalización: si el usuario lo
       AUTORIZÓ a mitad de sesión (prompt disparado por otra parte del sitio),
       el GPS se lee en silencio y el mensaje se actualiza sin recargar. */
    hbTicks++;
    if (hbTicks % 15 === 0 && w.COCoverage && w.COCoverage.refreshIfGranted) {
      w.COCoverage.refreshIfGranted();
    }
  }

  function init() {
    /* TAKEOVER: si otra carga de este script dejó un heartbeat vivo
       (doble script tag, harness embebido + assets del theme), lo matamos.
       Solo puede existir UNA fuente de pintado. */
    if (w.__CO_ANN_TIMER) { clearInterval(w.__CO_ANN_TIMER); w.__CO_ANN_TIMER = null; }

    if (w.COCoverage && w.COCoverage.resolve) {
      w.COCoverage.resolve(function () { repaint(); }); /* pinta al resolver */
    }
    repaint();
    /* Heartbeat de 1 s: recalcula desde estado fresco; el dedupe evita
       escrituras al DOM cuando nada cambió. Cubre countdown, corte 11am,
       cambio de día, cambio de zona y re-render externo de la sección. */
    w.__CO_ANN_TIMER = setInterval(heartbeat, 1000);
  }

  w.COAnnouncement = { refresh: repaint };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})(window);
